/*
 * Ported verbatim from the legacy app's scripts/app/components/flickity.js.
 * Relies on the global `jQuery` shim set up in main.js and the Flickity
 * jQuery bridge (imported before this module).
 */

(function ($) {
    var carousel = $('.main-carousel');
    if (carousel.length) {
        var autoPlay = carousel.data('autoplay');
        var $carousel = carousel.flickity({
            selectedAttraction: 0.04,
            friction: 0.35,
            cellAlign: 'left',
            contain: true,
            setGallerySize: false,
            pageDots: false,
            autoPlay: autoPlay
        });
        var cells = $carousel.find('.carousel-cell');
        var flkty = $carousel.data('flickity');

        $carousel.on('scroll.flickity', function () {
            flkty.slides.forEach(function (slide, i) {
                var x = (slide.target + flkty.x) * -1 / 1.5;
                cells[i].style['background-position'] = 'calc(50% + ' + x + 'px)';
            });
        });
    }

})(window.jQuery);
